import i18n from '@/translate/i18n';

const i18nOptions = { returnObjects: true };

export const weekDays = i18n.t('calendar.weekDays', i18nOptions);

export const months = i18n.t('calendar.months', i18nOptions);
